"use client"

import * as React from "react"
import { Area, AreaChart, CartesianGrid, XAxis, Bar, BarChart, YAxis, LabelList  } from "recharts"

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "src/@/components/ui/card"
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from "src/@/components/ui/chart"
import EmptyContentGhost from "src/components/EmptyContentGhost"

  const chartConfig = {
    desktop: {
      label: "Desktop",
      color: "#DACFFB",
    },
  }

export function GraficoCrmLeadsPorUsuarios({
    chartData
}) {

  return (
    <Card className="w-full">
      <CardHeader className="flex items-center gap-2 space-y-0 border-b border-gray-50 py-3 sm:flex-row">
      <h3 className="text-xl font-bold text-gray-800">
          Negócios criados por usuários
        </h3>
 
      </CardHeader>
      <CardContent>
        {
          chartData?.length === 0 ? (
            <EmptyContentGhost  />
          ) : (
            <ChartContainer className="w-full h-[250px]" config={chartConfig}>
            <BarChart
              accessibilityLayer
              data={chartData}
              layout="vertical"
              margin={{
                right: 16,
              }}
            >
              <CartesianGrid horizontal={false} />
              <YAxis
                dataKey="usuario_nome"
                type="category"
                tickLine={false}
                tickMargin={10}
                axisLine={false}
                tickFormatter={(value) => value.slice(0, 3)}
                hide
              />
              <XAxis dataKey="total_leads" type="number" hide />
              <ChartTooltip
                cursor={false}
                content={<ChartTooltipContent indicator="line" />}
              />
                                               <ChartLegend content={<ChartLegendContent nameKey="tipo" />} />

              <Bar
                dataKey="total_leads"
                layout="vertical"
                fill="var(--color-desktop)"
                radius={[10, 10, 0, 0]}
                barSize={30}
              >
                <LabelList
                  dataKey="usuario_nome"
                  position="insideLeft"
                  offset={8}
                  className="fill-[--color-label]"
                  fontSize={12}
                />
                <LabelList
                  dataKey="total_leads"
                  position="right"
                  offset={1}
                  className="fill-foreground"
                  fontSize={12}
                />
              </Bar>
            </BarChart>
          </ChartContainer>
          )
        }

      </CardContent>
    </Card>
  )
}
